import styled from 'styled-components';

export const Container = styled.div`

.div-input {
    position: relative;
    max-width: 663px;
    height: 78px;
    overflow: hidden;
    border-radius: 10px; 
    border: 0.25px solid lightgray;
    padding: 0;
    box-sizing: border-box;
    margin-bottom: 2.5rem;

    @media(max-width: 360px) {
        height: 64px;
        margin-bottom: 1.5rem;
    }
}

.div-input-disabled {
    position: relative;
    max-width: 663px;
    height: 78px;
    overflow: hidden;
    border-radius: 10px;
    border: 0.25px solid lightgray;
    padding: 0;
    box-sizing: border-box;
    background-color: #faf8f9;

    margin-bottom: 2.5rem;

    @media(max-width: 360px) {
        height: 64px;
        margin-bottom: 1.5rem;
    }
}

.div-input-focado {
    position: relative;
    max-width: 663px;
    height: 78px;
    overflow: hidden;
    border-radius: 10px;
    border: 0.25px solid #1c0506;
    padding: 0;
    box-sizing: border-box;

    margin-bottom: 2.5rem;

    @media(max-width: 360px) {
        height: 64px;
        margin-bottom: 1.5rem;
    }
}

.div-input-error {
    position: relative;
    max-width: 663px;
    height: 78px;
    overflow: hidden;
    border-radius: 10px;
    border: 0.25px solid #c32027;
    margin-bottom: 8px;
    padding: 0;
    box-sizing: border-box;

    @media(max-width: 360px) {
        height: 64px;
        margin-bottom: 1.5rem;
    }
}

.div-input input {
    font-family: Montserrat;        
    font-size: 16px;
    font-weight: 500;
    width: 80%;
    height: 100%;
    color: #1c0506;
    padding-top: 13px;
    border: none;
    outline: none;
    padding-left: 20px;

    :disabled {
        cursor: not-allowed;
        background: #faf8f9;
        width: 100%;
    }

    @media(max-width: 360px) {
        padding-top: 8px;
    }
}

.div-input-disabled input {
    font-family: Montserrat;        
    font-size: 16px;
    font-weight: 500;
    width: 80%;
    height: 100%;
    color: #1c0506;
    padding-top: 13px;
    border: none;
    outline: none;
    padding-left: 20px;

    :disabled {
        cursor: not-allowed;
        background: #faf8f9;
        width: 100%;
    }

    @media(max-width: 360px) {
        padding-top: 8px;
    }
}

.div-input-focado input {
    font-family: Montserrat;        
    font-size: 16px;
    font-weight: 500;
    width: 80%;
    height: 100%;
    color: #1c0506;
    padding-top: 13px;
    border: none;
    outline: none;
    padding-left: 20px;

    @media(max-width: 360px) {
        padding-top: 8px;
    }
}

.div-input-error input {
    font-family: Montserrat;        
    font-size: 16px;
    font-weight: 500;
    width: 80%;
    height: 100%;
    color: #c42027;
    padding-top: 13px;
    border: none;
    outline: none;
    padding-left: 20px;

    @media(max-width: 360px) {
        padding-top: 8px;
    }
}

.div-input label {
    font-family: Montserrat;
    font-weight: 600;
    color: lightgray;
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 100%;
    height: 100%;
    pointer-events: none;

    @media(max-width: 360px) {
        bottom: 12px;
    }
}

.div-input-disabled label {
    font-family: Montserrat;
    font-weight: 600;
    color: lightgray;
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 100%;
    height: 100%;
    pointer-events: none;

    @media(max-width: 360px) {
        bottom: 12px;
    }
}

.div-input-focado label {
    font-family: Montserrat;
    font-weight: 600;
    color: lightgray;
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 100%;
    height: 100%;
    pointer-events: none;

    @media(max-width: 360px) {
        bottom: 12px;
    }
}

.div-input-error label {
    font-family: Montserrat;
    font-weight: 600;
    color: lightgray;
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 100%;
    height: 100%;
    pointer-events: none;

    @media(max-width: 360px) {
        bottom: 12px;
    }
}

.div-input label::after {
    content: "";
    position: absolute;
    left: 0px;
    bottom: 10px;
    height: 100%;
    width: 100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}

.div-input-disabled label::after {
    content: "";
    position: absolute;
    left: 0px;
    bottom: 10px;
    height: 100%;
    width: 100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}

.div-input-focado label::after {
    content: "";
    position: absolute;
    left: 0px;
    bottom: 10px;
    height: 100%;
    width: 100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}

.div-input-error label::after {
    content: "";
    position: absolute;
    left: 0px;
    bottom: 10px;
    height: 100%;
    width: 100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
}

.content-name {
    position: absolute;
    bottom: 8px;
    left: 0px;
    transition: all 0.3s ease;
}

.div-input input:focus + .label-name .content-name,
.div-input input:valid + .label-name .content-name {
    transform: translateY(-150%);
    bottom: 0px;
    font-size: 12px;

    .div-input::after {
        border: none;
    }
}

.div-input-disabled input:focus + .label-name .content-name,
.div-input-disabled input:valid + .label-name .content-name,
.div-input-disabled input:disabled + .label-name .content-name {
    transform: translateY(-150%);
    bottom: 0px;
    font-size: 12px;

    .div-input::after {
        border: none;
    }
}

.div-input-focado input:focus + .label-name .content-name,
.div-input-focado input:valid + .label-name .content-name {
    transform: translateY(-150%);
    bottom: 0px;
    font-size: 12px;

    .div-input-focado::after {
        border: none;
    }
}

.div-input-error input:focus + .label-name .content-name,
.div-input-error input:valid + .label-name .content-name {
    transform: translateY(-150%);
    bottom: 0px;
    font-size: 12px;

    .div-input-error::after {
        border: none;
    }
}

.div-input input:focus + .label-name::after,
.div-input input:valid + .label-name::after {
    transform: translateX(0%);
}

.div-input-disabled input:focus + .label-name::after,
.div-input-disabled input:valid + .label-name::after {
    transform: translateX(0%);
}

.div-input-focado input:focus + .label-name::after,
.div-input-focado input:valid + .label-name::after {
    transform: translateX(0%);
}

.div-input-error input:focus + .label-name::after,
.div-input-error input:valid + .label-name::after {
    transform: translateX(0%);
}

.div-input button {
    position: absolute;
    right: 15px;
    top: 20px;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    border: none;
    align-self: center;
    box-sizing: border-box;
    font-size: 28px;

    :hover {
        opacity: 0.6;
    }
    .i {
        vertical-align: middle;
    }

    @media(max-width: 590px) {
        font-size: 22px;
        top: 25px;
    }
    @media(max-width: 360px) {
        font-size: 18px;
        top: 20px
    }
}

.div-input-disabled button {
    position: absolute;
    right: 15px;
    top: 20px;
    background-color: transparent;
    outline: none;
    cursor: not-allowed;
    border: none;
    align-self: center;
    box-sizing: border-box;
    font-size: 28px;

    :hover {
        opacity: 0.6;
    }
    .i {
        vertical-align: middle;
    }

    @media(max-width: 590px) {
        font-size: 22px;
        top: 25px;
    }
    @media(max-width: 360px) {
        font-size: 18px;
        top: 20px
    }
}

.div-input-focado button {
    position: absolute;
    right: 15px;
    top: 20px;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    border: none;
    align-self: center;
    box-sizing: border-box;
    font-size: 28px;

    :hover {
        opacity: 0.6;
    }
    .i {
        vertical-align: middle;
    }

    @media(max-width: 590px) {
        font-size: 22px;
        top: 25px;
    }
    @media(max-width: 360px) {
        font-size: 18px;
        top: 20px
    }
}

.div-input-error button {
    position: absolute;
    right: 15px;
    top: 20px;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    border: none;
    align-self: center;
    box-sizing: border-box;
    font-size: 28px;

    :hover {
        opacity: 0.6;
    }
    .i {
        vertical-align: middle;
    }

    @media(max-width: 590px) {
        font-size: 22px;
        top: 25px;
    }
    @media(max-width: 360px) {
        font-size: 18px;
        top: 20px
    }
}

    .header {
        display: flex;
        position: relative;
        align-items: center;
        justify-content: left;

        .banner {
            width: 100%;
            height: 362px;

            object-fit: cover;

            @media (max-width: 360px) {
                height: 416px;
            }
        }

            button {
                position: absolute;
                right: 0;
                top: 0;

                width: 2.5rem;
                height: 2.5rem;
                border-radius: 2.5rem;

                margin: 2rem;
                
                border: none;
                outline: none;
                background: var(--black);

                display: flex;
                align-items: center;
                justify-content: center;

                @media (max-width: 360px) {
                    margin: 1rem;
                }

                .icon {
                    padding: 0;
                    margin: 0;

                    font-size: 1.5rem;
                    color: var(--white);
                }
            }

        .content {
            position: absolute;
            padding-left: 2rem;

            display: flex;
            flex-direction: column;
            gap: 1.5rem;

            @media (max-width: 360px) {
                padding-left: 1rem;
            }

            img {
                width: 2rem;
                height: 2rem;
            }

            p {
                margin: 0;
            }

            h1 {
                margin: 0;
                line-height: 1.5;
                font-size: 2rem;
                // color: var(--white);
                

                @media (max-width: 360px) {
                    font-size: 1.5rem;
                    max-width: 299px
                }
            }

            h5 {
                font-weight: 400;
                margin: 0;
                line-height: 2;
                font-size: 1rem;
                // color: var(--white);
                opacity: 0.8;

                @media (max-width: 360px) {
                    max-width: 256px
                }

                span {
                    font-weight: bold;
                }
            }
        }
    }

    .destaques {
        padding: 3.5rem 2rem 3.8rem;
        display: flex;
        flex-direction: column;
        gap: 2.5rem;

        @media (max-width: 360px) {
            padding: 3.5rem 1rem 3.5rem;
            gap: 1.5rem;
        }

        h1 {
            font-size: 2rem;
            color: var(--black);

            padding: 0;
            margin: 0;

            @media (max-width: 360px) {
                font-size: 1.5rem;
            }
        }

        h5 {
            font-size: 1rem;
            color: var(--cor-neutra-300);
            font-weight: 400;

            padding: 0;
            margin: 0;

            @media (max-width: 360px) {
                line-height: 2;
                max-width: 257px;

            }

            span {
                font-weight: 600;
                color: var(--black)
            }
        }

        .produtos {
            padding-top: 1rem;
            display: flex;
            flex-direction: column;
            gap: 1.5rem;

            @media (max-width: 360px) {
                padding-top: 1.5rem;
            }

            .produto-filled {
                width: 100%;
                height: 80px;

                display: flex;
                box-sizing: border-box;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                background: var(--cor-neutra-100);
                border: 2px dashed var(--cor-neutra-1000);
                border-radius: 0.5rem;

                padding: 0 2rem;

                @media (max-width: 552px) {
                    padding: 8px 1.5rem;
                    //height: 168px;
                    height: auto;

                    gap: 0.5rem;
                }

                img {
                    width: 1rem;
                    height: 1rem;
                }

                span {
                    color: var(--cor-neutra-200);
                    font-size: 1rem;
                    font-weight: 600;
                }

                .middle-content {
                    display: none;
                    flex-direction: column;
                    align-items: left;
                    justify-content: center;

                    gap: 8px;

                    p {
                        margin: 0;
                        padding: 0;

                        font-size: 1rem;
                        font-family: Montserrat, sans-serif;
                        color: var(--cor-neutra-300)
                    }

                    span {
                        //font-weight: 600 !important;
                        font-size: 14px !important;
                    }

                    .font-weight {
                        font-weight: 600 !important;
                    }

                    @media (max-width: 552px) {
                        display: flex
                    }
                }

                .left {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: row;

                    gap: 1rem;

                    @media (max-width: 552px) {
                        .name {
                            display: none;
                        }

                        img {
                            margin-bottom: 4.75rem
                        }
                    }

                    img {
                        width: 48px;
                        height: 48px;
                        border-radius: 4px;

                        object-fit: cover;
                    }

                    span {
                        font-weight: 500;

                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;

                        max-width: 152px;
                    }
                }

                .right {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: row;

                    @media (max-width: 360px) {
                        position: relative
                    }

                    span {
                        font-size: 0.75rem;
                        font-weight: 500;

                        @media (max-width: 552px) {
                            display: none
                        }

                        a {
                            font-weight: 600;
                        }
                    }

                    button {
                        background: transparent;
                        outline: none;
                        border: none;

                        margin: 0 0 0 2rem;

                        @media (max-width: 692px) {
                            margin:0;
                        }

                        .icon {
                            color: #2a0709;
                            font-size: 1rem;

                            @media (max-width: 360px) {
                                color: var(--cor-neutra-300)
                            }
                        }
                    }
                }
            }

            .produto {
                width: 100%;
                height: 80px;

                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                
                gap: 1rem;

                border: 2px dashed var(--cor-neutra-300);
                border-radius: 0.5rem;

                cursor: pointer;

                @media (max-width: 552px) {
                    height: 120px;
                    flex-direction: column;

                    gap: 0.5rem;
                }

                img {
                    width: 1rem;
                    height: 1rem;
                }

                span {
                    color: var(--cor-neutra-200);
                    font-size: 1rem;
                    font-weight: 600;

                    @media (max-width: 552px) {
                        max-width: 155px;
                        text-align: center;
                    }
                }
            }
        }
    }

    .configurar {
        padding: 3.5rem 2rem 4rem;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;

        @media (max-width: 360px) {
            padding: 3.5rem 1rem 3.5rem;
        }

        img {
            width: 2rem;
            height: 2rem;
        }

        h1 {
            margin: 0;
            padding: 0;

            line-height: 1.5;

            @media (max-width: 360px) {
                font-size: 1.5rem;
                line-height: 1.67;
            }

            p {
                padding: 0;
                margin: 0;
            }
        }

        .inputs {
            padding-top: 2rem;

            @media (max-width: 360px) {
                padding-top: 1rem;
            }
        }

        .save {
            width: 120px;
            height: 40px;
            border-radius: 20px;
            margin-left: 600px;
            margin-top: 30px;

            outline: none;
            border: none;

            font-size: 0.6rem;
            font-weight: 600;
            color: var(--white);

            background: var(--red-100);
            transition: 0.2s;

            @media(max-width: 690px) {
                width: 100%;
                margin-left: 0px;
            }

            :hover {
                background-color:var(--red-200)
            }

            :active {
                background-color: var(--red-0)
            }
        }
    }

    .Textoh3{
        padding-top: 0px;
        font-size: 1.5rem;
        line-height: 1.5;
        font-weight: 700;
    }

    .subtextoh3{
        padding-right: 42px;
        margin-bottom: 5px;
        margin-top: 0;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        -webkit-letter-spacing: normal;
        -moz-letter-spacing: normal;
        -ms-letter-spacing: normal;
        letter-spacing: normal;
        text-align: left;
        color: #a49b9b;
    }

    .options  {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;

        @media(max-width: 360px) {
            width: 100%
        }
    }
        .option {
            cursor: pointer;
            margin-right: 16px;
            margin-bottom: 16px;
            border: 2.5px solid #2a0709;
            border-radius: 100px;
            padding: 12px 32px;

            @media(max-width: 360px) {
                padding: 6px 14px;
            }

            @media(max-width: 784px) {
                padding: 12px 24px;
            }
        

            span {
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 700;
                color: #2a0709;

                @media(max-width: 360px) {
                    font-size: 13px;
                }
            }
        }

        .option-selected {
            cursor: pointer;
            margin-right: 16px;
            margin-bottom: 16px;
            background-color: #2a0709;
            border: 2.5px solid #2a0709;
            border-radius: 100px;
            padding: 12px 32px;

            @media(max-width: 360px) {
                padding: 6px 14px;
            }

            @media(max-width: 784px) {
                padding: 12px 24px;
            }

            span {
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 700;
                color: #fff;

                @media(max-width: 360px) {
                    font-size: 13px;
                }
            }
        }

        .card {
            width: 100%;
            /* background-color: blue; */
            margin-top: -32px;
            margin-bottom: 50px;
            // display: flex;
            // flex-wrap: wrap;
            display: grid;
            grid-template-columns: repeat(3,1fr);
           

            @media(max-width: 480px) {
                margin-bottom: 56px;
                display: flex;
                flex-wrap: wrap;
            }

            .cartao {
                display: flex; 
                position: relative;
                flex-direction: row;
                align-items:center;
                height: 16px;
                margin-top: 40px;
                // margin-left: 5px;
                margin-right: 16px;
                list-style: none;
                flex: 0 0 28%;

                @media(max-width: 360px) {
                    margin-left: 16px;
                    margin-top: 48px;
                }

                .main { 
                    display: block; 
                    position: relative; 
                    cursor: pointer;
                    width: 230px;
                    @media (max-width: 360px) {
                        width: 280px;
                    }
                } 
          
                /* Hide the default checkbox */ 
                input[type=checkbox] { 
                    visibility: hidden; 
                    margin-right: 16px;
                } 
                
                /* Creating a custom checkbox 
                based on demand */ 
                .check { 
                    position: absolute; 
                    top: 0; 
                    left: 0;
                    height: 16px; 
                    width: 16px; 
                    border-radius: 3px;
                    background-color: #fff; 
                    border: 1px solid #a49a9b;

                    @media(max-width: 360px) {
                        top: 4px;
                    }
                } 

                .check-app { 
                    position: absolute; 
                    top: 0; 
                    left: 0;
                    height: 16px; 
                    width: 16px; 
                    border-radius: 3px;
                    background-color: #fff; 
                    border: 1px solid #a49a9b;

                    @media(max-width: 360px) {
                        top: 4px;
                    }
                } 
                
                /* Specify the background color to be 
                shown when hovering over checkbox */ 
                .main:hover input ~ .check { 
                    background-color: #ebedee; 
                } 
                
                /* Specify the background color to be 
                shown when checkbox is active */ 
                .main input:active ~ .check { 
                    background-color: #c42027; 
                    border: 1px solid #c42027
                } 
                
                /* Specify the background color to be 
                shown when checkbox is checked */ 
                .main input:checked ~ .check { 
                    background-color: #d7232c; 
                    border: 1px solid #d7232c
                } 

                .main input:checked ~ .check-app { 
                    // background-color: #dedede; 
                    background-color: #d7232c;
                    border: 1px solid #d7232c;
                } 
                
                /* Checkmark to be shown in checkbox */ 
                /* It is not be shown when not checked */ 
                .check:after { 
                    content: ""; 
                    position: absolute; 
                    display: none; 
                } 

                .check-app:after { 
                    content: ""; 
                    position: absolute; 
                    display: none; 
                } 
                
                /* Display checkmark when checked */ 
                .main input:checked ~ .check:after { 
                    display: block; 
                } 

                .main input:checked ~ .check-app:after { 
                    display: block; 
                } 
                
                /* Styling the checkmark using webkit */ 
                /* Rotated the rectangle by 45 degree and  
                showing only two border to make it look 
                like a tickmark */ 
                .main .check:after { 
                    left: 5px; 
                    bottom: 5px; 
                    width: 4px; 
                    height: 6px; 
                    border: solid white; 
                    border-radius: 1px;
                    border-width: 0 2px 2px 0; 
                    -webkit-transform: rotate(45deg); 
                    -ms-transform: rotate(45deg); 
                    transform: rotate(45deg); 
                } 

                .main .check-app:after { 
                    left: 5px; 
                    bottom: 5px; 
                    width: 4px; 
                    height: 6px; 
                    border: solid white; 
                    border-radius: 1px;
                    border-width: 0 2px 2px 0; 
                    -webkit-transform: rotate(45deg); 
                    -ms-transform: rotate(45deg); 
                    transform: rotate(45deg); 
                } 
            }
        }

        .div-app {

            h2 {
                margin-top: 72px;
                margin-left: 32px;
                margin-right: 16px;
                margin-bottom: 64px;
                font-family: Montserrat;
                font-size: 24px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #000000;
                
                @media(max-width: 360px) {
                    font-size: 16px;
                    margin-top: 56px;
                    margin-bottom: 56px;
                    margin-left: 16px;
                }
            }

            .img-app-disabled {
                width: 22px;
                height: 16px;
                object-fit: contain;
                opacity: 0.5;

                @media(max-width: 360px) {
                    width: 33px;
                    height: 24px;
                }
            }

        }

        .turno-fechado {
            margin-top: 10px;
            margin-right: 24px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            width: 204px;
            height: 88px;
            border: 1.5px solid #ececec;
            background-color: #faf8f8;
            border-radius: 10px;

            @media (max-width: 360px) {
                width: 100%;
                margin-left: 0px;
                width: 100%
            }

            .chevron {
                padding-right: 24px;
            }

            .left {
                padding-left: 24px;
            }

            h4 {
                margin: 0;
                padding: 0;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #2a0709;
            }
            h5 {
                margin: 0;
                margin-bottom: 12px;
                padding: 0;
                font-family: Montserrat;
                font-size: 12px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: left;
                color: #a49a9b;
            }
        }

        .horarios {
            width: 100%;
            flex-wrap: wrap;
            display: flex;
            margin-bottom: 30px;
            flex: 0 0 20%;

            @media (max-width: 360px) {
                    padding-left: 0px;
                    width: 100%;
                    flex: 1
                }
            }
            
            .date_picker {
                display: flex;
                /* padding-left: 30px; */
                padding-top: 10px;
                select {
                    height: 40px;
                    margin-left: 5px;
                }
            }

        .adicionar {
            margin: 2.5rem 0 0 0;
            width: 200px;
            //height: 40px;
            border-radius: 40px;
            padding: 16px 24px;

                outline: none;
                border: none;

                font-size: 0.6rem;
                font-weight: 600;
                color: var(--white);

                background: var(--red-100);
                transition: 0.2s;

                @media (max-width: 360px) {
                    width: 100%
                }

                :hover {
                    background-color:var(--red-200)
                }

                :active {
                    background-color: var(--red-0)
                }
            }


    .chevronDate {
        padding-right: 24px;
        display: flex;
        margin-right: 24px;
    }

    .chevronDate2 {
        padding-right: 24px;
        margin-left: 32px;
    }

    .txt-datepicker{
        margin: 0;
        padding: 0;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        text-align: left;
        color: #2a0709;
        margin-right: 50px;
    }
    .div-custom-datapicker{
        display: flex;
        align-items: center;
    }

    .chevron-datepicker{
        margin-top: -32px;
    }

    .price-before{
        text-decoration: line-through;
    }
`